import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/Admin.css";
import { Link } from "react-router-dom";
import Image from "../../assets/img/Logo.png";
import Logo from "../../assets/img/Logo2.png";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const CashierPanel = () => {
  const navigate = useNavigate();
  const dataUser = useSelector((state) => state.user.dataUser);

  useEffect(() => {
    if (dataUser === null || (dataUser.role_id !== 3 && dataUser.role_id !== 1)) {
      navigate("/");
    }
  }, [dataUser, navigate]);

  return (
    <div className="container">
      <Link to="/">
        <img src={Image} alt="logo" className="login-logo" />
      </Link>
      <div className="d-flex flex-column justify-content-center align-items-center min-vh-100 text-center">
        <h1 className="text-center admin-title">Panel de Cajero</h1>
        <p className="mb-4 fs-5 admin-subtitle">
          Aquí podrás gestionar las ordenes pendientes y cargar nuevos pedidos
        </p>
        <div className="d-grid justify-content-center gap-3">
          <button
            className="btn admin-btn-orange p-3"
            onClick={() => {
              navigate("/cashier/pending_orders");
            }}
          >
            Ver Pedidos Pendientes
          </button>

          <button
            className="btn admin-btn-green p-3"
            onClick={() => {
              // Redirigir directamente al flujo de pedidos
              navigate("/home/food_order");
            }}
          >
            Crear Nuevo Pedido
          </button>
        </div>
        <img src={Logo} alt="LogoBottom" className="w-50 d-flex mx-auto mt-5" />
      </div>
    </div>
  );
};

export default CashierPanel;
